<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="''"
            :headers="headers"
            :items="customrole"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteQuiz"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" @click="addQuiz" v-if="canAdd">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_CUSTOM_ROLE,
  DELETE_CUSTOM_ROLE,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "customrole",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    store.dispatch(FETCH_CUSTOM_ROLE, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Custom Role",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      custom_role_id: null,
      singleSelect: "",
      dialog: false,
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["customrole",'currentUser']),
    headers () {
      return [
        { text: this.$t("Id"), value: "custom_role_id" },  
        { text: this.$t("Custom Role Name"), value: "custom_role_name" },        
        { text: this.$t("Permissions"), value: "permissions" },        
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    }
  },
  methods: {
    addQuiz() {
      this.$router.push("/custom-role/add");
    },
    editing(id) {
      this.$router.push("/custom-role/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.custom_role_id = id
    },
    async deleteQuiz() {
      await this.$store
        .dispatch(DELETE_CUSTOM_ROLE, this.custom_role_id)
        .then(async resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.custom_role_id = null;
            await store.dispatch(FETCH_CUSTOM_ROLE, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
    canAdd(){
      if(typeof this.currentUser !== 'undefined') {
        if(this.currentUser.permissions.includes('can-create-custom-role') || this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3)){
          return true;
        }
      }
      return false;
    }
  }
};
</script>